import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import WeatherSlide from "./WeatherSlide";
import ExchangeRateSlide from "./ExchangeRateSlide";
import TopSocialFlipCard from "./TopSocialFlipCard";
import CountdownSlide from "./CountdownSlide";

const components = { weather: WeatherSlide, exchange: ExchangeRateSlide, social: TopSocialFlipCard, countdown: CountdownSlide };

export function localizedText(values, language) {
    return values?.[language?.split("-")[0]] || values?.kk || values?.ru || values?.en || "";
}

export default function ConfiguredWidgets({ widgets }) {
    const { t, i18n } = useTranslation();
    const visible = widgets.filter(widget => widget.enabled);
    // Two narrow slots beside the fixed print tile, then the lower area.
    // The sixth widget splits the lower left area, never the print tile.
    const slots = visible.length <= 5 ? [
        [7, 1, 2, 1], [7, 2, 2, 1], [1, 3, 4, 2], [5, 3, 4, 1], [5, 4, 4, 1],
    ] : [
        [7, 1, 2, 1], [7, 2, 2, 1], [1, 3, 4, 1], [5, 3, 4, 1], [1, 4, 4, 1], [5, 4, 4, 1],
    ];
    return visible.map((widget, index) => {
        const Component = components[widget.kind];
        const [column, row, width, height] = slots[index];
        return <div key={widget.id} className="min-w-0 min-h-0 overflow-hidden rounded-[3vh]"
            style={{ gridColumn: `${column} / span ${width}`, gridRow: `${row} / span ${height}` }}>
            {Component ? <Component compact={height === 1} narrow={width === 2} /> : widget.kind === "advertisement" ? (
                <Link to="/advertisement" className="h-full w-full rounded-[3vh] bg-white flex items-center justify-center text-[#246CE2] text-[2vh] font-bold">
                    {t("routeList.ad_placeholder")}
                </Link>
            ) : widget.kind === "notice" ? (
                <div className="h-full rounded-[3vh] bg-white p-[2vh_2vw] overflow-auto">
                    <h2 className="text-[2.4vh] font-bold text-[#12161F] break-words">{localizedText(widget.title, i18n.language)}</h2>
                    <p className="mt-[1vh] text-[1.8vh] text-[#7B8290] whitespace-pre-wrap break-words">{localizedText(widget.text, i18n.language)}</p>
                </div>
            ) : null}
        </div>;
    });
}
